import {Product} from "../model/product";
import {Document} from "../model/document";

export default class ProductUtils {

  public static BAUAK_DOCUMENT_NAMES = ["bauak", "pbauak", "statik", "bauakms"]

  /**
   * Finds the first Bauak-related document in the given list of documents
   *
   * Uses the predefined 'BAUAK_DOCUEMNT_NAMES' array to check whether a document's docnam
   * matches one of the known bauak  types.
   *
   * @param documents List of documents to search
   * @return First matching document if found, else null.
   */
  public static getBauakDocument(documents: Document[]): Document | null {
    return (documents.find(document =>
            this.BAUAK_DOCUMENT_NAMES.includes((document?.docname || "").toLowerCase())
        ) ?? null
    );
  }

  /**
   * Determines whether the product value dialog should be opened.
   * Checks if at least one product in the provided products contains product values.
   *
   * @param products Array of products to evaluate
   * @returns True if any product has defined product values, else false
   */
  public static shouldOpenProductValueDialog(products: Product[]): boolean {
    return products.some(product => product?.productValues && product.productValues.length > 0);
  }
}
